<div *ngIf="menu"
     [ngClass]="{ 'o365cs-base page-overlay': mobileMenusEnabled }"
     [attr.role]="mobileMenusEnabled ? 'dialog' : null"
     [attr.aria-modal]="mobileMenusEnabled ? true : null"
     ohpViewCacheOperation="remove-node">
    <!-- Used to blur background when menu is open on mobile -->
    <div *ngIf="mobileMenusEnabled" [@open]="animationState" class="page-overlay__background page-overlay__background--darker"></div>
    <div class="context-menu"
        [ngStyle]="menuStyle">
        <ohp-menu [menuModel]="menu.menu" [mobileMenu]="mobileMenusEnabled" (selectItem)="onSelectItem($event)" (closeMenu)="onCloseMenu()">
            <ng-container *ohpMenuItemContent="let item = item; let index = index;">
                <div class="actions-menu-item__flex-content">
                    <ohp-icon-font [iconFontType]="item.icon"
                                   [iconFontCssClass]="item.iconCssClass"
                                   size="16"
                                   [color]="item.iconColor"
                                   cssClass="actions-menu-item__icon ms-fcl-bl {{ mobileMenusEnabled ? 'actions-menu-item__icon--mobile' : '' }} {{ item.disabled ? 'menu-item__icon--disabled' : '' }}"></ohp-icon-font>
                    <div class="list-item__title menu-item__title ms-fcl-bl {{ item.disabled ? 'menu-item__title--disabled' : '' }}">{{ item.title }}</div>
                </div>
            </ng-container>
        </ohp-menu>
    </div>
</div>
